import React from "react";
import { MainLayout } from "../styles/Layouts";
import Resume from "../Components/Resume";
import { PageTransition } from "../Components/AnimatedComponents";

const ResumePage: React.FC = () => {
  return (
    <PageTransition>
      <MainLayout>
        <Resume />
      </MainLayout>
    </PageTransition>
  );
};

export default ResumePage;
